/**
 * @description Operation modify mode enum
 */
export enum OperationModifyMode {
    /**
     * @description Create operation mode
     */
    Create = 'create',

    /**
     * @description Update operation mode
     */
    Update = 'update',
}

/**
 * @description Union type for operation modify mode that accepts both enum values and string literals
 */
export type OperationModifyModeType = 'create' | 'update';

/**
 * @description Union type for operation modify mode that accepts both enum values and string literals
 */
export type IOperationModifyMode = OperationModifyMode | OperationModifyModeType;

/**
 * @description Operation mode enum
 */
export enum OperationMode {

    /**
     * @description View operation mode
     */
    Read = 'read',

    /**
     * @description Create operation mode
     */
    Create = 'create',
    /**
     * @description Update operation mode
     */
    Update = 'update',

    /**
     * @description Delete operation mode
     */
    Delete = 'delete',
}

/**
 * @description Union type for operation mode that accepts both enum values and string literals
 */
export type OperationModeType = 'read' | 'create' | 'update' | 'delete';

/**
 * @description Union type for operation mode that accepts both enum values and string literals
 */
export type IOperationModeUnion = OperationMode | OperationModeType;
